module.exports = __webpack_public_path__ + "media/printed-materials/educators-02-handout-b70070af.png";